import { Button, Form, Popup, ScrollView, TextBox } from 'devextreme-react';
import { Label } from 'devextreme-react/bar-gauge';
import { SimpleItem } from 'devextreme-react/form';
import React, { useEffect, useRef } from 'react';
import { InputOnlyNumber } from '../../common';

const CorpListCardInfoPopup = ({
  onHiding,
  onValueChanged,
  onClickSave,
  cardInfo,
  visibleCardInfoPopup,
}) => {
  // console.log('CorpListCardInfoPopup Load');

  const refCardNo1 = useRef(null);
  const refCardNo2 = useRef(null);
  const refCardNo3 = useRef(null);
  const refCardNo4 = useRef(null);
  const refExpireDate1 = useRef(null);
  const refExpireDate2 = useRef(null);
  const refPassword = useRef(null);
  const refAuthValue = useRef(null);

  useEffect(() => {
    // console.log('CorpListCardInfoPopup > useEffect()');

    if (refCardNo1.current) {
      setTimeout(() => {
        refCardNo1.current.instance.focus();
      }, 500);
    }
  }, [visibleCardInfoPopup]);

  return (
    <React.Fragment>
      <Popup
        title="결제카드 등록"
        visible={visibleCardInfoPopup}
        onHiding={onHiding}
        className="popup"
        maxWidth="30rem"
        maxHeight="30rem"
      >
        <ScrollView>
          <div className="corp-list-card-info-content popup-content">
            <Form formData={cardInfo} labelLocation={'left'} minColWidth={50}>
              <SimpleItem>
                <Label text="카드번호" />
                <div className="flex-row corp-list-card-num">
                  <TextBox
                    ref={refCardNo1}
                    width="3rem"
                    maxLength="4"
                    value={cardInfo.cardNo1}
                    onValueChanged={(e) => onValueChanged('cardNo1', e)}
                    onInput={(e) =>
                      InputOnlyNumber(e.event, refCardNo2.current)
                    }
                    onInitialized={(e) => {
                      setTimeout(() => {
                        e.component.focus();
                      }, 500);
                    }}
                  />
                  <TextBox
                    ref={refCardNo2}
                    width="3rem"
                    maxLength="4"
                    value={cardInfo.cardNo2}
                    onValueChanged={(e) => onValueChanged('cardNo2', e)}
                    onInput={(e) =>
                      InputOnlyNumber(e.event, refCardNo3.current)
                    }
                  />
                  <TextBox
                    ref={refCardNo3}
                    width="3rem"
                    maxLength="4"
                    value={cardInfo.cardNo3}
                    onValueChanged={(e) => onValueChanged('cardNo3', e)}
                    onInput={(e) =>
                      InputOnlyNumber(e.event, refCardNo4.current)
                    }
                  />
                  <TextBox
                    ref={refCardNo4}
                    width="3rem"
                    maxLength="4"
                    value={cardInfo.cardNo4}
                    onValueChanged={(e) => onValueChanged('cardNo4', e)}
                    onInput={(e) =>
                      InputOnlyNumber(e.event, refExpireDate1.current)
                    }
                  />
                </div>
              </SimpleItem>
              <SimpleItem>
                <Label text="유효기간(월/년)" />
                <div className="flex-row corp-list-valid">
                  <TextBox
                    ref={refExpireDate1}
                    width="2rem"
                    maxLength="2"
                    value={cardInfo.expireDate1}
                    onValueChanged={(e) => onValueChanged('expireDate1', e)}
                    onInput={(e) =>
                      InputOnlyNumber(e.event, refExpireDate2.current)
                    }
                  />
                  <div className="corp-list-delimiter">/</div>
                  <TextBox
                    ref={refExpireDate2}
                    width="2rem"
                    maxLength="2"
                    value={cardInfo.expireDate2}
                    onValueChanged={(e) => onValueChanged('expireDate2', e)}
                    onInput={(e) =>
                      InputOnlyNumber(e.event, refPassword.current)
                    }
                  />
                </div>
              </SimpleItem>
              <SimpleItem>
                <Label text="비밀번호" />
                <div className="flex-row corp-list-password">
                  <TextBox
                    ref={refPassword}
                    className="tiny-textbox"
                    width="2rem"
                    mode="password"
                    maxLength="2"
                    value={cardInfo.password}
                    onValueChanged={(e) => onValueChanged('password', e)}
                    onInput={(e) =>
                      InputOnlyNumber(e.event, refAuthValue.current)
                    }
                  />
                  <div>**</div>
                </div>
              </SimpleItem>
              <SimpleItem>
                <Label text="생년월일(6자) / 사업자번호" />
                <TextBox
                  ref={refAuthValue}
                  width="10rem"
                  maxLength="10"
                  value={cardInfo.authValue}
                  onValueChanged={(e) => onValueChanged('authValue', e)}
                  onInput={(e) => InputOnlyNumber(e.event)}
                />
              </SimpleItem>
            </Form>
          </div>
          <div className="corp-list-card-info-bottom">
            <Button
              stylingMode="contained"
              type="default"
              text="저장"
              onClick={onClickSave}
            />
            <Button
              stylingMode="contained"
              type="normal"
              text="닫기"
              onClick={onHiding}
            />
          </div>
        </ScrollView>
      </Popup>
    </React.Fragment>
  );
};

export default React.memo(CorpListCardInfoPopup);
